import { Link } from "react-router-dom";
import BrandLogo from "@components/BrandLogo";
import ActivityType from "../../../../components/ActivityType";
import { parseCMSBold } from "@app/Helpers.js";
import "./style.scss";
import DOMPurify from "dompurify";

export default function PrizeCard({
  mobileImg,
  desktopImg,
  imgDesc,
  copy,
  points,
  brands,
  completed = false,
  ident,
  type,
  highlighted,
  href,
  title,
  list,
  date = null,
  className = "",
  description = "",
  disabled = false,
  to,
  buttonCopy,
}) {
  const determineLink = () => {
    if (to) return to;
    return `/coupons/ultra-insider/redeem/${ident}`;
  };

  return (
    <div
      className={`ultra-activity-prize-card-component ${
        completed && type !== "Contest" ? "completed" : ""
      } ${className ? className : ""} ${highlighted ? "highlighted" : ""} ${disabled || ident === "" ? "disabled" : ""}`}
    >
      <Link to={completed && type !== "Contest" ? "/coupons" : determineLink()}>
        <div className="inner">
          <div className="img-wrapper">
            {/* {date && (
              <div className="image-copy">Du erhältst Zugang am: {date}</div>
            )} */}
            <picture>
              <source media="(min-width: 1020px)" srcSet={desktopImg} />
              <img src={mobileImg} alt={imgDesc} />
            </picture>
          </div>

          <div className={`award-info-wrapper ${href ? "with-button" : ""}`}>
            <div className="award-info">
              <p
                className="copy"
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parseCMSBold(copy))}}
              />

              {copy && (
                <>
                  <div className="divider"></div>
                </>
              )}

              {description && (
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description)}}
                />
              )}

              {list && (
                <div
                  className="list"
                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(list)}}
                />
              )}
            </div>
            {href && (
              <div className="prize-button">
                <div className="button-wrapper">
                  <div className="copy">
                    {buttonCopy ? buttonCopy : "Mehr entdecken"}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Link>
    </div>
  );
}
